<template>
  <div class="qs_content">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="问答详情：">
        <el-input v-model="searchForm.question" placeholder="请输入问答关键字"></el-input>
      </el-form-item>
      <el-form-item label="问答类型：">
        <el-select v-model="searchForm.qa_type" clearable placeholder="请选择">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addDialog = true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="question" label="问题" width="450"></el-table-column>
      <el-table-column prop="qa_type" label="文件类型" width="180"></el-table-column>
      <el-table-column label="操作人" width="250">
        <template slot-scope="scope">
          <span>{{scope.row.last_admin_username}}</span>
          <span style="margin-left: 10px;">{{$timeStamp(scope.row.last_admin_time)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="启用状态">
        <template slot-scope="scope">
          <el-switch 
            v-model="scope.row.status" 
            active-color="#13ce66" 
            :active-value="1" 
            :inactive-value="0"
            @change="changeStatus($event,scope.row.id)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope.row)" type="text">查看</el-button> -->
          <el-button type="text" size="small" @click="qaUpdata(scope.row)">更新</el-button>
          <el-button type="text" size="small" @click="qaDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>

    <!-- 新增问答-对话框 -->
    <el-dialog title="新增问答" :visible.sync="addDialog">
      <el-form :model="crteateForm">
        <el-form-item label="问答类型：" style="width:90%;" :label-width="formLabelWidth">
          <el-select v-model="crteateForm.qa_type" clearable placeholder="请选择">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题：" style="width:90%;" :label-width="formLabelWidth">
          <!-- <el-input type="textarea" :rows="5" resize="none" v-model="crteateForm.question" placeholder="请输入问题" autocomplete="off"></el-input> -->
          <Tinymce v-model="crteateForm.question"></Tinymce>
        </el-form-item>
        <el-form-item label="答案：" style="width:90%" :label-width="formLabelWidth">
          <!-- <el-input type="textarea" :rows="5" resize="none" v-model="crteateForm.answer" placeholder="请输入答案" autocomplete="off"></el-input> -->
          <Tinymce v-model="crteateForm.answer"></Tinymce>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 更新问答-对话框 -->
    <el-dialog title="更新问答" :visible.sync="updataDialog">
      <el-form :model="updataForm">
        <el-form-item label="问答类型：" style="width:90%;" :label-width="formLabelWidth">
          <el-select v-model="updataForm.qa_type" clearable placeholder="请选择">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题：" style="width:90%;" :label-width="formLabelWidth">
          <!-- <el-input type="textarea" :rows="5" resize="none" v-model="updataForm.question" placeholder="请输入问题" autocomplete="off"></el-input> -->
          <Tinymce v-model="updataForm.question"></Tinymce>
        </el-form-item>
        <el-form-item label="答案：" style="width:90%" :label-width="formLabelWidth">
          <!-- <el-input type="textarea" :rows="5" resize="none" v-model="updataForm.answer" placeholder="请输入答案" autocomplete="off"></el-input> -->
          <Tinymce v-model="updataForm.answer"></Tinymce>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updataDialog = false">取 消</el-button>
        <el-button type="primary" @click="updataSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"
import tokenService from "@/utils/services/token_service";
import Tinymce from "../../../components/Tinymce"
export default {
  mixins: [timestampToTime],
  name: "questionManagement",
  components: {
    Tinymce
  },
  data() {
    return {
      formInline: {
        user: '',
        region: ''
      },
      tableData: [],
      addDialog: false,
      updataDialog: false,
      formLabelWidth: '120px',
      form: {},
      value1: '',
      currentPage: 1,
      totalList: null,
      searchForm: {
        page: 1,
        pagesize: 10,
      },
      typeOptions: [
        {
          label: '风险评估'
        },
        {
          label: '风险预警'
        },
        {
          label: '安全培训'
        },
        {
          label: '日常管理'
        },
        {
          label: '应急处置'
        },
      ],
      crteateForm: {},
      updataForm: {},
    };
  },
  created() {
    this.getQaList()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    // 获取list
    async getQaList() {
      let params = {
        page: this.searchForm.page,
        pagesize: this.searchForm.pagesize,
      }
      if(this.searchForm.question){
        params.question = this.searchForm.question
      }
      if(this.searchForm.qa_type){
        params.qa_type = this.searchForm.qa_type
      }
      let res = await api.qaList(params)
      this.tableData = res.list
      this.totalList = res.recordcount;
      // this.pageSize = res.pagecount;
    },
    handleSizeChange(val) {
      this.searchForm.pagesize = val
      this.getQaList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchForm.page = val
      this.getQaList()
    },
    // list搜索
    search(){
      this.currentPage = 1
      this.searchForm.page = 1
      this.getQaList()
    },
    // 新增提交
    async addSubmit(){
      let res = await api.qaCreate(this.crteateForm)
      if(res.error_code == 0){
        this.$message.success("新增成功！")
        setTimeout(()=>{
          window.location.reload()
        },300)
        
        this.addDialog = false
      }
    },
    // 问答更新
    async qaUpdata(row){
      this.$set(this.updataForm,'id',row.id)
      this.$set(this.updataForm,'question',row.question)
      this.$set(this.updataForm,'answer',row.answer)
      this.$set(this.updataForm,'qa_type',row.qa_type)
      this.updataDialog = true
    },
    // 更新 提交
    async updataSubmit(){
      await api.qaEdit(this.updataForm)
      window.location.reload()
      this.updataDialog = false
    },
    // 问答 删除
    qaDelete(id){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await api.qaDelete({id:id})
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        setTimeout(()=>{window.location.reload()},300)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 改变状态
    async changeStatus(event,id){
      await api.qaEdit({
        id: id,
        status: event
      })
      // window.location.reload()
    }
  }
};
</script>

<style lang="scss" scoped>

.qs_content{
  background-color: #fff;
  margin: 15px;
  padding: 15px;
  height: 100%;
  .pagination {
    text-align: right;
    padding: 10px 20px;
  }
  
}
</style>
<style>
iframe{
  height: 120px!important;
}
.reply_area iframe{
  height: 100px!important;
}
 .mce-menubar ,.mce-panel {
  border: none!important;
}
.mce-edit-area .mce-container .mce-panel .mce-stack-layout-item{
  border: none!important;
}
.mce-flow-layout, .el-button--mini, .el-button--mini.is-round{
  display: none;
}
.mce-tinymce{
  box-shadow: none!important;
}
.mce-top-part::before{
  -webkit-box-shadow: none!important;
  box-shadow: none!important;
}
.tinymce-container{
  border: 1px solid #D4D4D4;
}
.txt img{
  display: block;
  margin-top: 17px;
  position: relative;
  width: 200px;
  margin: 0 auto;
}
</style>